export class Indication {
  id: number;
  createdOn: Date;
  updatedOn: Date;
  name: string;
  email: string;
  phone: string;
  message: string;
  userGuid: string;
  ipAddress: string;

  constructor(contentResponse: any) {
    this.id = parseInt(contentResponse.id ?? 0);
    this.name = contentResponse.name;
    this.email = contentResponse.email;
    this.phone = contentResponse.phone;
    this.ipAddress = contentResponse.ipAddress;
    this.message = contentResponse.message;
    this.userGuid = contentResponse.userGuid;
    this.createdOn = contentResponse.createdOn ? new Date(contentResponse.createdOn) : new Date();
    this.updatedOn = contentResponse.updatedOn ? new Date(contentResponse.updatedOn) : new Date();
  }
}
